import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { AiVideoGenCanvas } from '@/features/app-shell/canvases/ai-video-gen-canvas'

export const Route = createFileRoute('/app/tools/video-gen')({
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppToolsVideoGenPage,
})

function AppToolsVideoGenPage() {
  return (
    <AppShell activePath="/app">
      <AiVideoGenCanvas />
    </AppShell>
  )
}
